export default "__VITE_ASSET__f351af1e__"